interface FilterGroupProps {
  title: string;
  options: string[];
  value: string;
  onChange: (value: string) => void;
}

export default function FilterGroup({ title, options, value, onChange }: FilterGroupProps) {
  return (
    <div>
      <h3 className="text-xs tracking-[0.14em] text-foreground-400 font-label uppercase mb-2">{title}</h3>
      <div className="flex flex-wrap gap-1.5">
        {options.map((option) => {
          const active = option === value;
          return (
            <button
              key={option}
              type="button"
              onClick={() => onChange(option)}
              aria-pressed={active}
              className={`px-2.5 py-1 rounded-md text-xs transition-colors cursor-pointer whitespace-nowrap border ${
                active
                  ? "bg-primary-700 border-primary-700 text-background-50 font-medium"
                  : "bg-background-50 border-background-200 text-foreground-600 hover:border-accent-400 hover:text-accent-700"
              }`}
            >
              {option}
            </button>
          );
        })}
      </div>
    </div>
  );
}